import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import BigNumberCard from "components/BigNumberCard";  // Atualizado para o nome correto do componente
import ChartPessoas from "components/ChartPessoas";
import ChartDoughnut from "components/ChartDoughnut";
import ChangeLanguage from "components/ChangeLanguage";

import { useLanguage } from "context/LanguageContext";
import "./styled.scss";

import Svg1 from "assets/icon/1.svg";
import Svg2 from "assets/icon/2.svg";
import Svg3 from "assets/icon/3.svg";
import Svg5 from "assets/icon/5.svg";
import logo from "assets/img/cardux_login.png"; // Ajuste o caminho conforme necessário

const App = () => {
  const { GetTranslation } = useLanguage();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  // Estado inicial vazio para chartData e estados de carregamento/erro
  const [chartData, setChartData] = useState([]);
  const [Medidor1, setMedidor1] = useState(0);
  const [Medidor2, setMedidor2] = useState(0);
  const [Medidor3, setMedidor3] = useState(0);
  const [sobrevida, setSobrevida] = useState(0); // Alterado de 0.1 para 0
  const [mortalidade, setMortalidade] = useState(0); // Novo estado para taxa de mortalidade
  const [loading, setLoading] = useState(true); // Estado de carregamento
  const [error, setError] = useState(null); // Estado de erro

  const MascaraValor = (valor) => {
    if (valor !== undefined && valor !== null) {
      return valor.toFixed(2).replace(".", ",");
    }
    return "0,00"; // Retorna um valor padrão caso o valor seja indefinido ou nulo
  };

  // Função para fazer a chamada ao novo endpoint e atualizar o gráfico
  const fetchPercentualDados = () => {
    setLoading(true); // Ativa o estado de carregamento
    fetch(`${process.env.REACT_APP_API_URL}/cirurgia/percentuais`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success && data.data) {
          // Atualiza os dados do gráfico com os valores retornados pela API
          setChartData([
            { id: "congenita", nome:  GetTranslation("Congênita"), valor: data.data.congenita || 0, cor: "#6ce5e8" },
            { id: "coronario", nome: GetTranslation("Coronária"), valor: data.data.coronaria || 0, cor: "#41b8d5" },
            { id: "valvula", nome: GetTranslation("Válvula"), valor: data.data.valvula || 0, cor: "#2d8bba" },
            { id: "aorta", nome: GetTranslation("Aorta"), valor: data.data.aorta || 0, cor: "#2f5f98" },
          ]);
        } else {
          // Se os dados não estiverem presentes, define o gráfico com valores zerados
          setChartData([]);
        }
        setLoading(false); // Desativa o estado de carregamento
      })
      .catch((error) => {
        console.error("Erro ao buscar os percentuais", error);
        setError(error.message);
        setLoading(false); // Desativa o estado de carregamento
      });
  };

  // Função para buscar os tempos médios (IOT, UTI, LOS) e ajustar os BigNumberCards
  const fetchTemposMedios = () => {
    fetch(`${process.env.REACT_APP_API_URL}/pos_operatorio/tempos_medios`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success && data.data) {
          // Atualiza os valores dos BigNumberCards com os tempos médios retornados pela API
          setMedidor1(data.data.iot_media || 0);  // Tempo extubação após admissão UTI (IOT)
          setMedidor2(data.data.uti_media || 0);  // Tempo de permanência em UTI
          setMedidor3(data.data.los_media || 0);  // Tempo de permanência em internação hospitalar (LOS)
        } else {
          // Define os valores como 0 se os dados não forem encontrados
          setMedidor1(0);
          setMedidor2(0);
          setMedidor3(0);
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar os tempos médios", error);
        setError(error.message);
      });
  };

  // Função para buscar a taxa de mortalidade
  const fetchMortalidade = () => {
    fetch(`${process.env.REACT_APP_API_URL}/obito/mortalidade`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success && data.taxa_mortalidade !== undefined) {
          const taxaMortalidade = data.taxa_mortalidade;
  
          // Certifica que taxaMortalidade é um número antes de calcular
          if (typeof taxaMortalidade === "number" && !isNaN(taxaMortalidade)) {
            setMortalidade(taxaMortalidade);
            setSobrevida(100 - taxaMortalidade);
          } else {
            console.error("Taxa de mortalidade inválida");
            setSobrevida(0); // Define como 0 ou um valor padrão
          }
        } else {
          // Define como 0 se a taxa de mortalidade não for encontrada
          setMortalidade(0);
          setSobrevida(0);
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar a taxa de mortalidade", error);
        setError(error.message);
      });
  };

  useEffect(() => {
    if (!token) {
      navigate("/");
      return;
    }

    fetchPercentualDados(); // Chama a função ao montar o componente
    fetchTemposMedios(); // Chama a função para buscar os tempos médios
    fetchMortalidade(); // Chama a função para buscar a taxa de mortalidade
  }, [token, navigate]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  if (loading) {
    return <p>Carregando dados...</p>; // Exibe mensagem de carregamento
  }

  if (error) {
    return <p>Erro: {error}</p>; // Exibe mensagem de erro
  }

  return (
    <div className="bg-app">
      <div className="certe-context">
        <div className="logo-container">
          <img src={logo} alt="Logo" className="logo" />
        </div>
        <h1>CarduMICS</h1>
        <h2>{GetTranslation("dashboard")}</h2>
        <div className="box-cards">
          <div className="card">
            <Link to={"/app/form/identificacao"} className="item min-item not-link">
              <img src={Svg1} alt="cadastrar-novo-paciente" />
              <p>{GetTranslation("new_patient_registration")}</p>
            </Link>
            <Link to={"/app/home"} className="item min-item not-link">
              <img src={Svg2} alt="meus-pacientes" />
              <p>{GetTranslation("my_patients")}</p>
            </Link>
            <div className="item min-item">
              <img src={Svg3} alt="gerar-relatorio" />
              <p>{GetTranslation("generate_report")}</p>
            </div>
            <Link
              to={"/"}
              className="item min-item not-link"
              onClick={handleLogout}
            >
              <img src={Svg5} alt="logout" />
              <p>{GetTranslation("logout")}</p>
            </Link>
          </div>
          <div className="card">
            <ChangeLanguage />
          </div>
        </div>
        <div className="card mt-3">
          <div className="grid">
            <div className="titolo">
              <h3>{GetTranslation("my_summary")}</h3>
            </div>
            <div className="t1">
              <h4 className="m-0">{GetTranslation("surgeries")}</h4>
            </div>
            <div className="t2">
              <h4 className="m-0">{GetTranslation("times")}</h4>
            </div>
            <div className="t3">
              <h4 className="m-0">{GetTranslation("survival")}</h4>
            </div>
            <div className="info-1">
              <ChartDoughnut data={chartData} />
            </div>
            <div className="info-2">
              <div className="d-flex flex-column gap-1">
                <div className="d-flex flex-row gap-2">
                  <BigNumberCard valor={Medidor1} label={GetTranslation("IOT_h")} />
                </div>
                <div className="d-flex flex-row gap-2">
                  <BigNumberCard valor={Medidor2} label={GetTranslation("UTI_h")} />
                </div>
                <div className="d-flex flex-row gap-2">
                  <BigNumberCard valor={Medidor3} label={GetTranslation("LOS_h")} />
                </div>
              </div>
            </div>
            <div className="info-3">
              <div className="item">
                <ChartPessoas valor={sobrevida > 0 ? sobrevida : 0}></ChartPessoas> {/* Garante que sobrevida seja maior que 0 */}
                <p className="m-0 mt-2">
                  {MascaraValor(sobrevida)} %{" "} {/* Exibindo a sobrevida corretamente */}
                  {GetTranslation("in_30_days")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
